export default __webpack_public_path__ + "static/media/ramsay-sime-darby-logo.c20a1af8.png";